// //Avec Route Browser
import React, { useEffect, useState } from "react";
// import { Navigate, Outlet, Route, Routes } from "react-router-dom";

// import logo from "./logo.svg";
import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";

// import Base from "./views/Base.js";
// import Main from "./views/Home.js";
// import PrivateRoute from "./auth/PrivateRoute";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import routes from "./routes";
import routesV2 from "./routes-v2";
import { HotelContextProvider } from "./context/HotelContext";
import { LanguageProvider } from "./context/LanguageContext";
//import CentralizeRedirect from "auth/CentralizeRedirect";
// import replicated from "auth/replicated";
// import Home from "./views/Home.js";
import { useAuth } from "react-oidc-context";
// import ScrollToTop from "utils/ScrollToTop";

// Fusionner les routes v1 et v2
const allRoutes = [...routes, ...routesV2];
const router = createBrowserRouter(allRoutes);

const App = () => {
    const keycloak = useAuth();

    const [loading, setLoading] = useState(true);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Fonction de vérification de la largeur de la fenêtre
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Vérifiez la largeur au chargement
        handleResize();

        // Écoutez les changements de taille d'écran
        window.addEventListener("resize", handleResize);

        // Nettoyez l'événement lors du démontage
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setLoading(false);
    }, [keycloak.isAuthenticated]);

    const login = () => {
        keycloak.signinRedirect();
    };

    const logout = () => {
        keycloak.signoutRedirect();
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    const isSimulatorPage =
        window.location.pathname.startsWith("/simulateur-accor-groupe");

    if (isMobile && !isSimulatorPage) {
        return (
            <div style={{ textAlign: "center", padding: "20px" }}>
                <h1>Application non disponible sur mobile</h1>
                <p>
                    Veuillez utiliser cette application sur un appareil de plus
                    grande taille.
                </p>
            </div>
        );
    }

    return (
        <LanguageProvider>
            <HotelContextProvider>
                {/* Utilisation du RouterProvider pour gérer les routes */}
                <RouterProvider router={router} />
                {/* Boutons de connexion et déconnexion */}
                {/* {!keycloak.isAuthenticated ? (
                        <button onClick={login}>Se connecter</button>
                    ) : (
                        <button onClick={logout}>Se déconnecter</button>
                    )} */}
            </HotelContextProvider>
        </LanguageProvider>
    );
};

// Example of a private component accessible only for authenticated users
const PrivateComponent = () => {
    return <h2>Private Component - Only accessible for authenticated users</h2>;
};

export default App;
